//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from '~sdp-components/Header/Header'
import Navigation from '~/components/Navigation'
import Footer from '~sdp-components/Footer/Footer'

export default {
  components: {
    Header,
    Navigation,
    Footer,
  },
}
